import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import "./Experience.css";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import CountUp from "react-countup";

function Experience({ darkMode }) {
  const [windowSize, setWindowSize] = useState(window.pageYOffset);
  const [progressActive, setProgressActive] = useState(false);
  const [html, setHtml] = useState(0);
  window.addEventListener("scroll", () => {
    setWindowSize(window.pageYOffset);
  });

  useEffect(() => {
    if (windowSize > 1400) {
      setProgressActive(true);
    } else {
      setProgressActive(false);
    }
    //console.log(html.current.offsetTop);
  }, [windowSize]);

  return (
    <section id="experience">
      <h5>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInLeftBig"
        >
          What SKills I Have
        </AnimationOnScroll>
      </h5>
      <h2>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          My Experience
        </AnimationOnScroll>
      </h2>

      <div
        className={
          darkMode
            ? "container experience__container"
            : "container experience__container light"
        }
      >
        <div className="experience__frontend">
          <h3>
            <AnimationOnScroll
              animateOnce="true"
              animateIn="animate__fadeInLeftBig"
            >
              Frontend Development
            </AnimationOnScroll>
          </h3>
          <AnimationOnScroll
            animateOnce="true"
            animateIn="animate__fadeInLeftBig"
          >
            <div className="experience__content">
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>HTML</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "html" : "html__reduce"}>
                      <small per="88%">
                        {progressActive ? (
                          <>
                            <CountUp start={1} end={88} delay={0} duration={3}>
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>CSS</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "css" : "css__reduce"}>
                      <small per="85%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={85}
                              delay={0}
                              duration={3.1}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Javascript</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div
                      className={
                        progressActive ? "javascript" : "javascript__reduce"
                      }
                    >
                      <small per="85%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={85}
                              delay={0}
                              duration={3.2}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Bootstrap</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div
                      className={
                        progressActive ? "bootstrap" : "bootstrap__reduce"
                      }
                    >
                      <small per="83%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={83}
                              delay={0}
                              duration={3.3}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Taiilwind</h4>
                  <small className="text-light">Experienced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div
                      className={
                        progressActive ? "tailwind" : "tailwind__reduce"
                      }
                    >
                      <small per="54%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={54}
                              delay={0}
                              duration={3.4}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>React , Redux</h4>
                  <small className="text-light">Experienced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "react" : "react__reduce"}>
                      <small per="70%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={70}
                              delay={0}
                              duration={3.5}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Vue , Vuex</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "vue" : "vue__reduce"}>
                      <small per="80%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={80}
                              delay={0}
                              duration={3.6}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>GIT</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "vue" : "vue__reduce"}>
                      <small per="80%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={80}
                              delay={0}
                              duration={3.6}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </AnimationOnScroll>
        </div>
        <div className="experience__backend">
          <h3>
            <AnimationOnScroll
              animateOnce="true"
              animateIn="animate__fadeInRightBig"
            >
              Backend Development
            </AnimationOnScroll>
          </h3>
          <AnimationOnScroll
            animateOnce="true"
            animateIn="animate__fadeInRightBig"
          >
            <div className="experience__content">
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>PHP</h4>
                  <small className="text-light">Experienced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "php" : "php__reduce"}>
                      <small per="70%">
                        {progressActive ? (
                          <>
                            <CountUp start={1} end={70} delay={0} duration={3}>
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Laravel</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div
                      className={progressActive ? "laravel" : "laravel__reduce"}
                    >
                      <small per="87%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={87}
                              delay={0}
                              duration={3.1}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>MySQL</h4>
                  <small className="text-light">Advanced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "mysql" : "mysql__reduce"}>
                      <small per="87%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={87}
                              delay={0}
                              duration={3.2}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Node.js</h4>
                  <small className="text-light">Experienced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "node" : "node__reduce"}>
                      <small per="76%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={76}
                              delay={0}
                              duration={3.3}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>Mongoose</h4>
                  <small className="text-light">Experienced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div
                      className={
                        progressActive ? "mongoose" : "mongoose__reduce"
                      }
                    >
                      <small per="70%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={70}
                              delay={0}
                              duration={3.4}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
              <article className="experience__details">
                <BsPatchCheckFill className="experience_details_icon" />
                <div className="progress__details">
                  <h4>C</h4>
                  <small className="text-light">Experienced</small>
                  <div
                    className={
                      darkMode ? "progress__bar" : "progress__bar light"
                    }
                  >
                    <div className={progressActive ? "C" : "C__reduce"}>
                      <small per="50%">
                        {progressActive ? (
                          <>
                            <CountUp
                              start={1}
                              end={50}
                              delay={0}
                              duration={3.4}
                            >
                              {({ countUpRef, start = false }) => (
                                <div className="count">
                                  <span ref={countUpRef} />%
                                </div>
                              )}
                            </CountUp>
                          </>
                        ) : (
                          "0 %"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </AnimationOnScroll>
        </div>
      </div>
    </section>
  );
}

export default Experience;
